import React, { FC, useState, useEffect } from 'react';

import { Bar, ChartData } from 'react-chartjs-2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import * as chartjs from 'chart.js';
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import i18n from 'i18next';
import { AhorroPorMesObj } from '../../../types/Types';
import { useAppStore } from '../../../store/AppContext';
import { useAuthStore } from '../../../store/AuthContext';
import { HostProvider } from '../../../utils/HostProvider';

interface Periodo {
  year: number;
  month: number;
}

type Props = {
  data: AhorroPorMesObj[];
  periodo: Periodo;
  reload: boolean;
  setReload: (value: boolean) => void;
};
const BarCharts: FC<Props> = ({ data, periodo, reload, setReload }) => {
  const { t } = useTranslation();
  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const { moneda } = dataUser.user;
  const isEroski = HostProvider.isEroski();

  const barColor = isEroski ? '#cd0810' : '#36b4e3';
  const selectedBarColor = isEroski ? '#840705' : '#0f69b2';
  /**
   * nuevos
   */
  const [labelsBar, setLabelsBar] = useState<string[]>([]);
  const [dataBar, setDataBar] = useState<number[]>([]);
  const [datasets, setDatasets] = useState<ChartData<chartjs.ChartData>>({});
  const arrayColors: any[] = [];

  const op = {
    responsive: true,
    maintainAspectRatio: false,
    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: 0,
          borderColor: 'black',
          borderWidth: 3,
          label: {
            content: 'Test Label',
            enabled: false,
          },
        },
      ],
    },
    layout: {
      padding: { top: 15 },
    },
    legend: {
      display: false,
    },
    tooltips: {
      displayColors: true,
      callbacks: {
        title(tooltipItem: any, dataR: any) {
          return dataR.labels[tooltipItem[0].index];
        },
        label(tooltipItem: any, dataR: any) {
          return `${dataR.datasets[0].data[tooltipItem.index]}${
            moneda === 'euro' ? t('euro') : t('cc')
          } de ahorro`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            display: true,
            stepSize: 1,
          },
          gridLines: {
            display: true,
          },
          stacked: true,
        },
      ],
      xAxes: [
        {
          stacked: true,
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };
  const [options, setOptions] = useState<object>(op);
  const prepareBars = () => {
    if (data !== undefined && data !== null && data.length > 0) {
      const periodoConcat =
        String(periodo.month).length === 1
          ? String(periodo.year).concat(
              '0',
              String(!reload ? periodo.month : periodo.month),
            )
          : String(periodo.year).concat(
              '',
              String(!reload ? periodo.month : periodo.month),
            );
      data.forEach((value) => {
        if (periodoConcat === String(value.month))
          arrayColors.push(selectedBarColor);
        else arrayColors.push(barColor);
      });
      const d = data.map((value) => (value.ahorro < 0 ? 0 : value.ahorro));
      setDataBar(d);
      const l = data.map((value) => {
        let month = String(value.month).slice(4, 6);
        if (month.slice(0, 1) === '0') {
          month = month.slice(-1);
        }
        return moment()
          .month(Number(month) - 1)
          .locale(dataApp.lang)
          .format('MMMM');
      });
      setLabelsBar(l);
      setDatasets({
        labels: labelsBar,
        datasets: [
          {
            label: moneda,
            data: dataBar,
            backgroundColor: arrayColors,
            borderWidth: 1,
          },
        ],
      });
      const stepSize = 0;

      const sum = d.reduce((a, b) => a + b, 0);
      const avg = sum / d.length;
      setOptions({
        responsive: true,
        maintainAspectRatio: false,
        annotation: {
          annotations: [
            {
              type: 'line',
              mode: 'horizontal',
              scaleID: 'y-axis-0',
              value: avg,
              borderColor: 'black',
              borderWidth: 3,
              label: {
                content: 'Test Label',
                enabled: false,
              },
            },
          ],
        },
        layout: {
          padding: { top: 15 },
        },
        legend: {
          display: false,
        },
        tooltips: {
          displayColors: true,
          callbacks: {
            title(tooltipItem: any, dataR: any) {
              return dataR.labels[tooltipItem[0].index];
            },
            label(tooltipItem: any, dataR: any) {
              return `${dataR.datasets[0].data[tooltipItem.index]}${
                moneda === 'euro' ? t('euro') : t('cc')
              } de ahorro`;
            },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: false,
                display: true,
                stepSize,
              },
              gridLines: {
                display: true,
              },
              stacked: true,
            },
          ],
          xAxes: [
            {
              barPercentage: 0.6,
              stacked: true,
              gridLines: {
                display: false,
              },
            },
          ],
        },
      });
    }
  };
  useEffect(() => {
    prepareBars();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, dataBar.length, i18n.language]);

  useEffect(() => {
    if (reload) {
      prepareBars();
      setReload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <>
      <Bar
        data={datasets}
        height={300}
        options={options}
        plugins={[ChartAnnotation]}
      />
    </>
  );
};

export default BarCharts;
